export function ucFirst(string: string) {
    return (string.charAt(0).toUpperCase() + string.slice(1)) as any;
}
